import { render, staticRenderFns } from "./TripDetail.vue?vue&type=template&id=56935698&scoped=true"
import script from "./TripDetail.vue?vue&type=script&lang=js"
export * from "./TripDetail.vue?vue&type=script&lang=js"
import style0 from "./TripDetail.vue?vue&type=style&index=0&id=56935698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56935698",
  null
  
)

export default component.exports